/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    PieceCreateEndToEndTestMutation$data,
    PieceCreateEndToEndTestMutation$variables
} from "mutation/__generated__/PieceCreateEndToEndTestMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation PieceCreateEndToEndTestMutation($input: MusicCreatePieceEndToEndTestInput!) {
        music_create_piece_end_to_end_test(input: $input) {
            success
        }
    }
`;

export default async function PieceCreateEndToEndTest(pieceId: string): Promise<void> {
    const variables: PieceCreateEndToEndTestMutation$variables = {
        input: {
            piece_id: pieceId
        }
    };
    await perform<PieceCreateEndToEndTestMutation$data>(mutation, variables);
    return
}